import { isEmpty, Dictionary, get, isNil, some, isNumber } from 'lodash';
import { AssignmentMeta, AssignmentType } from '../../assignment';

export namespace QuizQuestion {
  export type AnswerValue = { answers: string[] };
  export interface Answer {
    values: AnswerValue[]; // TODO: Rename history?
    modifiedAt: number;
  }

  export type AnswerResult = {
    type: 'correct' | 'incorrect';
  };

  // also edit isCorrectAnswer after change
  export type CorrectAnswer = AnswerValue[];

  export namespace Answer {
    export function isDone(answer: Answer | undefined): boolean {
      return answer ? !isNil(latestAnswer(answer)) : false;
    }

    export function latestAnswer(answer: Answer | undefined): AnswerValue | undefined {
      const values = (answer && answer.values) || [];
      return values[values.length - 1];
    }
  }
}
